import { render, staticRenderFns } from "./CustomerSelection.vue?vue&type=template&id=95bd7154&scoped=true"
import script from "./CustomerSelection.vue?vue&type=script&lang=js"
export * from "./CustomerSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bd7154",
  null
  
)

export default component.exports